var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "ticker-popover",
      style: { left: `${_vm.left}px`, width: `${_vm.width}px` },
      attrs: { role: "dialog", "aria-label": _vm.title },
    },
    [
      _c("span", {
        staticClass: "ticker-popover__arrow",
        style: { left: `${_vm.arrowLeft}px` },
      }),
      _c("header", { staticClass: "ticker-popover__header" }, [
        _vm.showBack
          ? _c(
              "button",
              {
                staticClass: "ticker-popover__back",
                attrs: { type: "button", "aria-label": _vm.$t("Back") },
                on: {
                  click: function ($event) {
                    return _vm.$emit("back")
                  },
                },
              },
              [_vm._v(" ‹ ")]
            )
          : _vm._e(),
        _c("h2", { staticClass: "ticker-popover__title" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
        _c(
          "button",
          {
            staticClass: "ticker-popover__close",
            attrs: { type: "button", "aria-label": _vm.$t("Close") },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/images/quick-play-close.svg"),
                alt: "",
              },
            }),
          ]
        ),
      ]),
      _c(
        "div",
        {
          ref: "body",
          staticClass: "ticker-popover__body",
          on: { scroll: _vm.syncFade },
        },
        [_vm._t("default")],
        2
      ),
      _vm.hasMoreBelow
        ? _c("span", { staticClass: "ticker-popover__fade" })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }